export default __webpack_public_path__ + "static/media/iam_xl1.a0afc43b.png";